// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 20:05:35

export default {
  "id": "taptapboom",
  "slug": "taptapboom",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/c145d75289014880982a013ec9390d1c-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/c145d75289014880982a013ec9390d1c/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "TapTapBOOM",
      "description": "Blast your way through 30 challenging levels in this cute and explosive physics game, where all you need is to TapTapBOOM!",
      "instructions": "Solve the physics puzzles by placing bombs. Tap 2 times to place your bombs then a third to make them explode. You can also explode TNT by tapping the plunger. Switches can be triggered by exploding them. Can you solve all the puzzles?",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2d",
        "bomb",
        "cute",
        "physics",
        "skill"
      ]
    },
    "zh-CN": {
      "title": "TapTapBOOM\n（根据上下文，这可能是一个游戏名称或游戏内的动作指令）",
      "description": "通过30个挑战关卡，在这款可爱且充满爆炸力的物理游戏中，你只需轻点TapTapBOOM！即可畅玩。",
      "instructions": "通过放置炸弹解决物理谜题。点击两次放置炸弹，第三次引爆。你也可以通过按下压杆引爆TNT。通过引爆可以触发开关。你能解决所有谜题吗？",
      "genres": [
        "谜题"
      ],
      "tags": [
        "2D",
        "炸弹",
        "可爱",
        "物理",
        "技巧"
      ]
    },
    "zh-TW": {
      "title": "TapTapBOOM",
      "description": "橫掃30個挑戰等級，在這款可愛且充滿爆炸的物理遊戲中，你只需點擊TapTapBOOM！即可。",
      "instructions": "解開物理謎題，請放置炸彈。點擊兩次放置炸彈，第三次點擊使其爆炸。您還可以點擊壓棒使TNT爆炸。爆炸可以觸發開關。你能解開所有謎題嗎？",
      "genres": [
        "謎題"
      ],
      "tags": [
        "2D",
        "炸彈",
        "可愛",
        "物理",
        "技巧"
      ]
    },
    "zh-HK": {
      "title": "TapTapBOOM → 轻觸BOOM",
      "description": "炸飛通過這款可愛且充滿爆炸的物理遊戲的30個挑戰關卡，你只需輕輕點擊TapTapBOOM！即可。",
      "instructions": "解開物理謎題，請放置炸彈。輕觸兩下以放置炸彈，第三次輕觸則引發爆炸。你還可以輕觸壓把使TNT爆炸。引信可以被爆炸觸發。你能解開所有謎題嗎？",
      "genres": [
        "謎題"
      ],
      "tags": [
        "二維",
        "炸彈",
        "可愛",
        "物理",
        "技巧"
      ]
    },
    "ja": {
      "title": "タップタップブム",
      "description": "この可愛くて爆発的な物理ゲームで、30レベルの挑戦的なステージを爆破してTapTapBOOM！で進めましょう",
      "instructions": "物理パズルを解くために爆弾を配置します。爆弾を配置するには2回タップ、爆発させるには3回目のタップです。TNTを押しボタンで爆発させることもできます。スイッチは爆発させることで作動させられます。すべてのパズルを解けますか？",
      "genres": [
        "パズル"
      ],
      "tags": [
        "2D",
        "爆弾",
        "可愛い",
        "物理",
        "スキル"
      ]
    },
    "ko": {
      "title": "탭탭보웨임",
      "description": "이 귀여운 폭발물리학 게임을 통해 30개의 도전적인 레벨을 통과하세요. 여기서 필요한 것은 단순히 탭탭보올 뿐입니다!",
      "instructions": "물리 퍼즐을 해결하기 위해 지뢰를 둡니다. 지뢰를 둘 때는 두 번, 폭발시키기 위해 세 번 탭하세요. TNT를 냉수대로 탭하여 폭발시킬 수도 있습니다. 스위치는 폭발로 트리거할 수 있습니다. 모든 퍼즐을 해결할 수 있을까요?",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "2D",
        "지뢰",
        "귀여운",
        "물리학",
        "기술"
      ]
    },
    "fr": {
      "title": "TapTapBOOM",
      "description": "Explosez votre chemin à travers 30 niveaux défiants dans ce jeu de physique mignon et explosif, où tout ce dont vous avez besoin est de cliquer et de faire BOUM !",
      "instructions": "Résolvez les puzzles de physique en placant des bombes. Tapez deux fois pour placer vos bombes puis un troisième pour les faire exploser. Vous pouvez également faire exploser du TNT en appuyant sur le levier. Les interrupteurs peuvent être déclenchés en les explosant. Pouvez-vous résoudre tous les puzzles ?",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "2D",
        "bombe",
        "mignon",
        "physique",
        "compétence"
      ]
    }
  }
};
